var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "account_white_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m271.01,236.35h-111.75c-29.33,0-56.91,11.42-77.63,32.16-20.69,20.68-32.12,48.18-32.17,77.44l-.45,14.23c-.1,3.26,1.14,6.46,3.4,8.8,2.27,2.34,5.43,3.68,8.69,3.68h307.16c6.57,0,11.88-5.15,12.09-11.71l.46-14.41v-.39c0-29.34-11.41-56.92-32.16-77.65-20.73-20.74-48.3-32.17-77.65-32.17Zm-197.42,112.12l.06-1.92v-.39c0-22.86,8.92-44.36,25.08-60.54,16.18-16.17,37.68-25.08,60.54-25.08h111.74c22.86,0,44.36,8.91,60.54,25.08,16.12,16.13,25.03,37.56,25.08,60.35l-.08,2.5H73.59Z",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.74,64.02c-11.16-5.32-23.14-8.02-35.6-8.02-22.13,0-42.93,8.62-58.56,24.26-15.65,15.64-24.26,36.44-24.26,58.57,0,22.13,8.61,42.93,24.26,58.57,15.63,15.65,36.43,24.26,58.57,24.26h.02c22.12,0,42.92-8.62,58.55-24.26,15.65-15.64,24.27-36.44,24.26-58.57,0-19.45-6.87-38.35-19.38-53.24-7.6-9.05-17.23-16.51-27.86-21.57Zm5.87,116.27c-11.08,11.07-25.81,17.17-41.46,17.18-15.65,0-30.38-6.1-41.46-17.17-11.07-11.08-17.17-25.81-17.18-41.46,0-15.65,6.1-30.38,17.17-41.46,11.08-11.07,25.81-17.17,41.46-17.18,8.82,0,17.29,1.91,25.18,5.67,7.51,3.58,14.32,8.84,19.64,15.16l.11.13c8.84,10.52,13.7,23.91,13.71,37.68,0,15.65-6.1,30.38-17.17,41.46Z",
    style: {
      fill: "#f7f7f7"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountWhite);
export default __webpack_public_path__ + "static/media/account_white.ceb3f83e1a69a4e0565dd23d1e69e779.svg";
export { ForwardRef as ReactComponent };